import React from "react";
import ceoImg from "../images/ceo.jpg";
import logoImg from "../images/logo.png";

const AboutUs = () => {
  return (
    <>
      <div className="aboutus-wrapper">
        {/* Header Logo */}
        <div className="aboutus-logo">
          <img src={logoImg} alt="VOETA Logo" />
        </div>

        {/* Welcome Message */}
        <section className="aboutus-hero">
          <h1>Welcome to VOETA</h1>
          <p>
            VOETA is a multi-sector enterprise delivering high-quality services in travel, security, real estate, construction, and cleaning. We proudly serve individuals, businesses, and institutions with a commitment to trust, innovation, and reliability.
          </p>
        </section>

        {/* Mission and Vision */}
        <section className="aboutus-section">
          <div className="text">
            <h2>Our Mission</h2>
            <p>
            We enrich lives and empower communities by providing essential services with integrity, professionalism, and care. Our mission is to foster lasting relationships built on trust and respect, continuously innovate to meet evolving needs, and deliver solutions that create meaningful impact. At VOETA, we are dedicated to uplifting individuals, businesses, and institutions by offering reliable and accessible services that enhance quality of life and drive sustainable growth.
            </p>

            <h2>Our Vision</h2>
            <p>
            To be the most trusted, accessible, and people-driven ecosystem of services — where excellence meets purpose. We envision a future where VOETA stands as a beacon of innovation and social responsibility, seamlessly integrating multiple service sectors to create a holistic experience for our clients. Our vision is to empower communities through collaboration, embrace technology to improve service delivery, and lead with values that inspire confidence and drive positive change locally and beyond.
            </p>
          </div>
        </section>

        {/* Core Values */}
        <section className="aboutus-section values">
          <h2>Our Core Values</h2>
          <ul className="value-grid">
            <li><strong>Trust:</strong> Built through transparency and reliability.</li>
            <li><strong>Efficiency:</strong> Delivering timely and effective solutions.</li>
            <li><strong>Confidentiality:</strong> Your privacy is our priority.</li>
            <li><strong>Quality:</strong> Consistent standards that exceed expectations.</li>
            <li><strong>Accountability:</strong> We take ownership of every result.</li>
            <li><strong>Community:</strong> We believe in people, progress, and purpose.</li>
          </ul>
        </section>

        {/* CEO Section */}
        <section className="aboutus-section ceo">
          <div className="ceo-image-wrapper">
            <img src={ceoImg} alt="Peter Luckson Ngolu - CEO of VOETA" />
          </div>
          <div className="ceo-text">
            <h2>Owner, Founder & CEO</h2>
            <p>
              <strong>PETER LUCKSON NGOLU</strong> is the owner, founder, and CEO of VOETA. In early 2022, while living in Denver, Colorado, United States, he was inspired to create VOETA — a business born in response to both personal challenges and the struggles faced by many in his community. With deep insight into local needs and a passion for service excellence, he transformed a bold idea into a thriving, multi-sector enterprise.
            </p>

            <p>
              His leadership is grounded in discipline, innovation, and people-first values — building services that are trustworthy, impactful, and forward-thinking.
            </p>
          </div>
        </section>

        {/* Services Summary */}
        <section className="aboutus-section services">
          <h2>Our Divisions</h2>
          <ul>
            <li><strong>Travel Agency:</strong> Visa support, relocation, asylum assistance, and DV lottery services.</li>
            <li><strong>Security Agency:</strong> Trained guards, surveillance, and event security solutions.</li>
            <li><strong>Cleaning Agency:</strong> Residential, corporate, and industrial cleaning services.</li>
            <li><strong>Real Estate Agency:</strong> Property sales, rentals, and full-service management.</li>
            <li><strong>Construction Agency:</strong> Comprehensive infrastructure and building projects.</li>
          </ul>
        </section>

        {/* Footer Statement */}
        <section className="aboutus-footer">
          <p>
            VOETA is more than a service provider — we’re a mission-driven partner committed to delivering trust, quality, and excellence in every engagement.
          </p>
          <p><strong>VOETA — Built to Serve. Powered by Trust.</strong></p>
        </section>
      </div>

      {/* Embedded CSS */}
      <style>
        {`
          .aboutus-wrapper {
            font-family: 'Segoe UI', sans-serif;
            color: #222;
            max-width: 1200px;
            margin: auto;
            padding: 2rem 1rem;
            background: #fff;
            line-height: 1.6;
          }

          .aboutus-logo {
            text-align: center;
            margin-bottom: 2rem;
          }

          .aboutus-logo img {
            width: 120px;
            height: auto;
          }

          .aboutus-hero {
            text-align: center;
            margin-bottom: 3rem;
          }

          .aboutus-hero h1 {
            font-size: 2.5rem;
            color: #0d47a1;
            margin-bottom: 1rem;
          }

          .aboutus-hero p {
            font-size: 1.1rem;
            color: #444;
            max-width: 800px;
            margin: 0 auto;
          }

          .aboutus-section {
            margin: 3rem 0;
          }

          .aboutus-section h2 {
            font-size: 2rem;
            color: #007bff;
            margin-bottom: 1rem;
          }

          .aboutus-section p {
            font-size: 1rem;
            color: #333;
          }

          .value-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
            gap: 1rem;
            list-style: none;
            padding: 0;
            margin-top: 1rem;
          }

          .value-grid li {
            background: #f8f9fa;
            border-left: 4px solid #007bff;
            padding: 1rem;
            border-radius: 6px;
          }

          .ceo {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: space-between;
            gap: 2rem;
          }

          .ceo-image-wrapper {
            flex: 1;
            min-width: 300px;
            max-width: 400px;
            order: 1;
          }

          .ceo-text {
            flex: 2;
            min-width: 300px;
            order: 2;
          }

          .ceo-image-wrapper img {
            width: 100%;
            height: auto;
            border-radius: 10px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          }

          .ceo-quote {
            font-style: italic;
            color: #555;
            margin-top: 1rem;
          }

          .services ul {
            list-style: disc;
            padding-left: 1.5rem;
            margin-top: 1rem;
          }

          .services li {
            margin-bottom: 0.75rem;
          }

          .aboutus-footer {
            text-align: center;
            border-top: 1px solid #ddd;
            margin-top: 3rem;
            padding-top: 2rem;
            font-size: 1rem;
            color: #555;
          }

          .aboutus-footer strong {
            display: block;
            margin-top: 1rem;
            color: #0d47a1;
          }

          /* Responsive Adjustments */
          @media (max-width: 768px) {
            .ceo {
              flex-direction: column;
              text-align: center;
            }

            .ceo-image-wrapper {
              order: 1;
            }

            .ceo-text {
              order: 2;
            }

            .value-grid {
              grid-template-columns: 1fr;
            }

            .aboutus-hero h1 {
              font-size: 2rem;
            }

            .aboutus-section h2 {
              font-size: 1.5rem;
            }
          }
        `}
      </style>
    </>
  );
};

export default AboutUs;
